import { createAction } from "@reduxjs/toolkit";
import { EXERCISE_SALE_SEARCH, EXERCISE_SALE_SEARCH_CLEAR } from "./exerciseSaleFiltersType";
import { ExerciseSaleSearchParams } from "../../models/ExerciseSaleSearchParams";

export const searchExerciseSale = createAction<{ search: ExerciseSaleSearchParams }>(EXERCISE_SALE_SEARCH);
export const clearExerciseSaleFilters = createAction<void>(EXERCISE_SALE_SEARCH_CLEAR);
